export const DEFAULT_ANNUAL_MILEAGE_VALUE = 12000;

export const DEFAULT_RESIDUAL_VALUE = 0;
